// Necessary if using App Router to ensure this file runs on the client
'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { env } from '../../../_config/env.client';

/**
 * @description -  Render nothing - this component is only included so that the RUM initialization code will run client-side
 * In order to get the version we need to pass it as a prop from the layout which is rendered server side
 *
 * @see {@link https://docs.datadoghq.com/real_user_monitoring/guide/monitor-your-nextjs-app-with-rum}
 *
 */
export function DatadogRumInit({ version }: { version?: string | undefined }) {
  useEffect(() => {
    if (datadogRum.getInternalContext() === undefined) {
      datadogRum.init({
        applicationId: env.NEXT_PUBLIC_DATADOG_RUM_APPLICATION_ID,
        clientToken: env.NEXT_PUBLIC_DATADOG_RUM_CLIENT_TOKEN,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.com',
        service: 'maui',
        env: env.NEXT_PUBLIC_APP_ENV,
        version: version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [/https:\/\/.*\.fff-dev\.com/, /https:\/\/.*\.fabfitfun\.com/],
      });
    }
  }, [version]);
  return null;
}
